import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
import styled from "styled-components";
import {
  BaseFieldStyle,
  FieldWrapper,
  Label,
  RequiredMark,
  ErrorText,
} from "./SharedFormStyles";

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    ${BaseFieldStyle}
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & input {
    padding: 10px;
    font-family: ${({ theme }) => theme.fonts.primary};
  }

  & .MuiAutocomplete-inputRoot {
    padding: 0;
  }
`;

const FormSelectField = ({
  name,
  label,
  control,
  error = null,
  options,
  required = false,
  placeholder = "Select an option",
  disabled = false,
}) => {
  return (
    <FieldWrapper>
      {label && (
        <Label variant="body1" component="label" htmlFor={name}>
          {label} {required && <RequiredMark>*</RequiredMark>}
        </Label>
      )}

      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            disabled={disabled}
            options={options}
            value={options.find((option) => option.value === value) || null}
            onChange={(event, newValue) =>
              onChange(newValue ? newValue.value : "")
            }
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                placeholder={placeholder}
                error={!!error}
              />
            )}
          />
        )}
      />

      {error && <ErrorText variant="body2">{error.message}</ErrorText>}
    </FieldWrapper>
  );
};

// PropTypes
FormSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  control: PropTypes.object.isRequired,
  error: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormSelectField;
